export default [
  { id: 'English', title: 'English', value: 'English', label: 'English' },
  { id: 'French', title: 'French', value: 'French', label: 'French' },
  {
    id: 'Portuguese',
    title: 'Portuguese',
    value: 'Portuguese',
    label: 'Portuguese'
  },
  { id: 'Italian', title: 'Italian', value: 'Italian', label: 'Italian' },
  { id: 'Greek', title: 'Greek', value: 'Greek', label: 'Greek' },
  { id: 'Spanish', title: 'Spanish', value: 'Spanish', label: 'Spanish' },
  { id: 'Arabic', title: 'Arabic', value: 'Arabic', label: 'Arabic' },
  { id: 'Japanese', title: 'Japanese', value: 'Japanese', label: 'Japanese' },
  { id: 'German', title: 'German', value: 'German', label: 'German' },
  { id: 'Korean', title: 'Korean', value: 'Korean', label: 'Korean' },
  { id: 'Dutch', title: 'Dutch', value: 'Dutch', label: 'Dutch' },
  { id: 'Chinese', title: 'Chinese', value: 'Chinese', label: 'Chinese' },
  { id: 'Swedish', title: 'Swedish', value: 'Swedish', label: 'Swedish' },
  { id: 'Danish', title: 'Danish', value: 'Danish', label: 'Danish' },
  { id: 'Russian', title: 'Russian', value: 'Russian', label: 'Russian' },
  {
    id: 'Norwegian',
    title: 'Norwegian',
    value: 'Norwegian',
    label: 'Norwegian'
  },
  { id: 'Turkish', title: 'Turkish', value: 'Turkish', label: 'Turkish' },
  { id: 'Finnish', title: 'Finnish', value: 'Finnish', label: 'Finnish' },
  { id: 'Polish', title: 'Polish', value: 'Polish', label: 'Polish' },
  { id: 'Czech', title: 'Czech', value: 'Czech', label: 'Czech' },
  { id: 'Indian', title: 'Indian', value: 'Indian', label: 'Indian' },
  {
    id: 'Hungarian',
    title: 'Hungarian',
    value: 'Hungarian',
    label: 'Hungarian'
  },
  { id: 'Hebrew', title: 'Hebrew', value: 'Hebrew', label: 'Hebrew' },
  { id: 'Croatian', title: 'Croatian', value: 'Croatian', label: 'Croatian' },
  { id: 'Slovak', title: 'Slovak', value: 'Slovak', label: 'Slovak' }
];
